export default function addGoogleAdOnIngridMidBanner(items, aNoOfProdsPerRow) {
  const googleAdOnIngridMidItem = {
    googleAdOnIngridMidBanner: {},
    fullWidth: true,
    excludeRow: true,
  };
  /* istanbul ignore else */
  if (items.length > ((aNoOfProdsPerRow * 2))) {
    const startIndex = (aNoOfProdsPerRow * 5) + 1;
    return [
      ...items.slice(0, startIndex),
      googleAdOnIngridMidItem,
      ...items.slice(startIndex),
    ];
  }

  return items;
}
